const cent = '00';
const complement = '0';

export function currencyFormat(num) {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

export function currencyStringFormat(num) {
  return `${(num * 1).toLocaleString('en-EN', { minimumFractionDigits: 2 })}`;
}

export const integerPart = (val) => {
  const currency = currencyFormat(val);
  return currency.split('.')[0];
};

export const decimalPart = (val) => {
  // do not return single digit for cent part of the price
  const deci = val.toString().split('.')[1];
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(deci)) return cent;
  if (deci.length === 1) return deci.concat(complement);

  return deci;
};
